import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SuccessConfirm"
});
const _hoisted_1 = {
  t: "1662601300832",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6413",
  width: "200",
  height: "200"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M854.304 203.904a41.568 41.568 0 0 1 58.24 0l35.36 34.912a40.384 40.384 0 0 1 0 57.6l-530.56 523.68a41.568 41.568 0 0 1-58.272 0L76.096 540.8a40.384 40.384 0 0 1 0-57.6l35.36-34.912a41.568 41.568 0 0 1 58.24 0l218.464 215.552z",
  "p-id": "6414",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var successConfirm = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { successConfirm as default };
